import axios from "../login/Axios-interceptor";

const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;

const DOCTOR_LIST_ENDPOINTS = [
  "get_all_doctors/",
  "get_doctors_based_on_facility_user/",
];

const fetchDoctorsFromEndpoint = async (token, endpoint) => {
  const response = await axios.get(`${REACT_APP_BACKEND_ROUTE_URL}${endpoint}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (response.data?.status !== "Success") {
    return [];
  }

  return response.data?.data ?? response.data?.doctor_list ?? [];
};

/**
 * Loads doctors for Doctor Console Manager.
 * Tries all known doctor-list endpoints so any role can open the Manager.
 */
export const fetchDoctorsForConsoleManager = async (token) => {
  if (!token) return [];

  for (const endpoint of DOCTOR_LIST_ENDPOINTS) {
    try {
      const list = await fetchDoctorsFromEndpoint(token, endpoint);
      if (list.length > 0) {
        return list;
      }
    } catch (err) {
      console.warn(`Doctor list endpoint failed: ${endpoint}`, err);
    }
  }

  return [];
};

/** @deprecated UI copy only — all roles use the same doctor fetch logic now. */
export const isFacilityScopedConsoleManagerRole = () => true;

export const resolveDefaultDoctorId = ({ doctors, userInfo, sessionDoctorId }) => {
  const list = doctors ?? [];
  if (!list.length) {
    return userInfo?.doctor_id != null
      ? String(userInfo.doctor_id)
      : sessionDoctorId != null
        ? String(sessionDoctorId)
        : null;
  }

  const ownId = userInfo?.doctor_id ?? sessionDoctorId;
  if (ownId != null && list.some((d) => String(d.doctor_id) === String(ownId))) {
    return String(ownId);
  }

  return String(list[0].doctor_id);
};
